        <template>
         <div>
        <!-- navbar -->
         <Navigation> </Navigation>
        <!-- navbar --> 
    <div class="mt-5">
        <div class="container ">
            <h1 class="mt-5 display-4 about-main-heading">Aruvaa Crafts Happiness</h1>

                <div class=" grid md:grid-cols-2  grid:cols-1 gap-4">
                    <div class="">
                        <h5 style="font-weight:600 ">We not only write codes, we craft happiness for our clients and customers. We craft business softwares
                        for small and medium-sized enterprises(SME), which helps them manage, supervise and grow their business effectively and efficiently.
                     </h5>  
                    </div>
                    <!-- ... -->
                    <div class="">
                        <img src="imgs/about_logo.png" class="img-fluid home-banner-image1" alt="" >
                    </div>
                </div>
        
        </div>
    </div>

     <section>
        <div class="container" style="position: relative;">

            <div style="position: relative;">
                <!-- <span class="sub-title-shadow">Sustainable values to customers</span> -->
                <span class="sub-title">Sustainable values to customers</span>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6">
                    <div>
                        <p class="sub-title-text">&rarr;We always value all our partners and are committed to accompanying customers to bring the best value to the community. <br>

                        &rarr;We are constantly boosting passions, connecting members to bring higher values to the community. </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

     <section>
        <div class="container">
            <h2 class="values-heading">Our values</h2>
            <table>
                <tr>
                    <td>
                        <i class="far fa-check-circle ic_circle_tick"></i>
                    </td>
                    <td class="lead values-list-text"> &nbsp;
                        Integrity &amp; Trust
                    </td>
                </tr>
                <tr>
                    <td>
                        <i class="far fa-check-circle ic_circle_tick"></i>
                    </td>
                    <td class="lead values-list-text"> &nbsp;
                        Innovation
                    </td>
                </tr>
                <tr>
                    <td>
                        <i class="far fa-check-circle ic_circle_tick"></i>
                    </td>
                    <td class="lead values-list-text"> &nbsp;
                        Customer happiness
                    </td>
                </tr>
                <tr>
                    <td>
                        <i class="far fa-check-circle ic_circle_tick"></i>
                    </td>
                    <td class="lead values-list-text"> &nbsp;
                        Customer success
                    </td>
                </tr>
                <tr>
                    <td>
                        <i class="far fa-check-circle ic_circle_tick"></i>
                    </td>
                    <td class="lead values-list-text"> &nbsp;
                        Equality
                    </td>
                </tr>
                <tr>
                    <td>
                        <i class="far fa-check-circle ic_circle_tick"></i>
                    </td>
                    <td class="lead values-list-text"> &nbsp;
                        Invest in people </td>
                </tr>
            </table>
        </div>
    </section>

    <section>
       <div class="container">
            <h1 class="mt-5 display-4 about-main-heading ">Aruvaa - A Unique Concept </h1>
             <div style="position: relative;">
                <!-- <span class="sub-title-shadow">Concept of Aruvaa</span> -->
                <span class="sub-title">Concept of Aruvaa</span>
            </div>
            
                <div class=" grid md:grid-cols-2  grid:cols-1 gap-4">
                    <div class="">
                        <p class="sub-title-text">Thousands of years ago the ancient rishis could identify two tiny spots in the sky as a twin star system. They named it Arundhati-Vasistha.
                        <br><br>There are many twin star system in the sky. In these twin star system, one star remains at center and the order revolves around it. But Arundhati-Vasistha is a very
                        special type of twin star system in which both the stars are revolving around each other with a mutual coupling and harmony. The relation and understanding between an organisation and its clients should also be in harmony.
                        <br> <br>
                        The name Aruvaa is coined from Arundhati-Vasistha. Just like the harmony between these twin star system, we maintain our harmony with our obedient clients, beautiful society, reliable suppliers and our hardworking employees and vice versa.

                 </p>
                    </div>
                    <!-- ... -->
                    <div class="">
                        <img src="imgs/about_aruvaa.png" class="img-fluid home-banner-image1" alt="" width="90%" >
                    </div>
                </div>
            
        
        </div> 
    </section>

    </div>
     <Footer > </Footer>
        </template>
        
      <style scoped>
           @media only screen and (min-width: 1200px) {
        .container{
            text-align:left;
           font-weight: 100;
        }
        
        }
       
   * {
        outline: none;
        overflow:hidden;
    }
    .mt-5{
       margin-top:4rem 
    }
    .section-all{
  margin: 50px;
    }
.img_size{
    height: auto;
    width: 190px;
}
    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    /*Scroll - END*/


    /*Typing Animation - START*/

    .fake-typing p {
        font-size: 3.5rem;
        padding: 0.5rem;
        font-weight: bold;
        letter-spacing: 0.1rem;
        overflow: hidden;
    }

    .fake-typing p span.typed-text {
        font-weight: normal;
        color: #dd7732;
    }

    .fake-typing p span.cursor {
        display: inline-block;
        background-color: #ccc;
        margin-left: 0.1rem;
        width: 3px;
        animation: blink 1s infinite;
    }

    .fake-typing p span.cursor.typing {
        animation: none;
    }

    @keyframes blink {
        0% {
            background-color: #ccc;
        }

        49% {
            background-color: #ccc;
        }

        50% {
            background-color: transparent;
        }

        99% {
            background-color: transparent;
        }

        100% {
            background-color: #ccc;
        }
    }

    /*Typing Animation - END*/



    .about-main-heading {
        font-weight: bold !important;
        color: var(--blue);
    }

    .sub-title {
        font-weight: bold !important;
        font-size: 40px;
        left: 0;
    }

    .sub-title-shadow {
        font-weight: bold !important;
        color: var(--blue);
        font-size: 70px;
        opacity: 0.1;
        position: absolute;
        top: -30px;
    }


    .main-title-shadow {
        font-weight: bold !important;
        color: var(--blue);
        font-size: 90px;
        opacity: 0.1;
        position: absolute;
        top: -30px;
    }


    .culture-title {
        font-weight: bold !important;
        font-size: 40px;
        left: 0;
    }

    .search-button {
        border: 1px solid #011969;
        font-style: normal;
        margin-left: 4px;
        font-weight: 800;
        background-color: #001969;
        color: white;
    }

    .search-button:hover {
        text-decoration: none;
        color: #ffffff;
    }

    /* .nav-link-header {
        color: #9c761f !important;
        font-weight: 600 !important;
        font-size: 20px;
    } */

    .sub-title-text {
        font-weight: 700;
        font-size: 17px;
    }

    .values-heading {
        color: var(--blue);
    }

    .ic_circle_tick {
        color: var(--blue);
        font-weight: bold;
    }

    .values-list-text {
        font-weight: 400 !important;
    }


/* image style  start from here */
     
 .img-culture {
        border-radius: 10px;
    }

    .img-culture-one {
        border-radius: 15px;
    }

    .img-culture-two {
        border-radius: 10px;
        margin-left: 90px;
        margin-top: -80px;
        box-shadow: 0 0 10px 1px #33383C;
    }

    .culture-div {
        border: 1px solid #ffffff;
        border-radius: 10px;
       
        padding: 8px;
        transition: 0.2s;
    }

    .culture-div:hover {
        border: 1px solid #CECECE;
    }

    .culture-card-text {
        font-size: 12px;
        font-weight: 500;
        line-height: 120%;

    }
    .navbar {
        position: fixed !important;
        display: flex;
        align-items: center;
        padding: 0.3rem 0rem;
       

    }
      </style>

   <script>
       
       import { Head, Link } from '@inertiajs/inertia-vue3';
       import Footer from "@/Layouts/Footer.vue";
       import Navigation from "@/Layouts/Navigation.vue";
       import AppLayout from "@/Layouts/AppLayout.vue";
       export default {
      
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
        },
        components: {
    AppLayout,
    Navigation,
    Footer,
  },
         data() {
        return {
            url: '/' 
        }
    }

    }
        </script>